import React, { useEffect } from 'react';
import {
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import Services from './services';
import SelectButtons from './SelectButtons';
import _ from 'lodash';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';

const CsoportosForm = props => {
  const {
    helyszinId,
    formTerem,
    formTeremkiosztas,
    formPublikus,
    formMaxjegyszam,
    formKenyelmidij,
    formKenyelmidijsz,
    formRendelesIdoLimit,
    formRendelesTorlesIdoLimit,
    formEsemenyTipus,
    formTulajdonsag,
    formPenznem,
    jegySWExists,
    csoportDays,
    addWeek,
    selectDay,
    selectedDays,
    csoportosIdoOptions,
    formEloadasIdotartam,
    formIdopontok,
    handleChangeInput,
    handleSelectInputChange,
    handleAddIopont,
    globals,
    penznemOptions,
    kenyelmiDijParam,
    kenyelmiDijInputChecker
  } = props;

  useEffect(() => {
    setDefaultPenznem();
  }, []);

  const setDefaultPenznem = () => {
    Services.getDefaultPenznem((err, res) => {
      if (!err) {
        handleSelectInputChange(res[0], "formPenznem");
      }
    });
  }

  const loadTeremkiosztasOptions = (input, callback) => {
    if(helyszinId){
      Services.listTeremkiosztas(helyszinId, formTeremkiosztas && formTeremkiosztas.kod, (err, res) => {
        if (!err) {
          let options = [];
          if(res[0][helyszinId]){
            res[0][helyszinId].filter( tk => tk.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
              options.push(item);
            });
          }
          callback(options);
        }
      });
    }
  }

  const loadTeremOptions = (input, callback) => {
    if(helyszinId){
      Services.listTeremSelect(helyszinId, (err, res) => {
        if (!err) {
          let options = [];
          res[0].filter( t => t.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
            options.push(item);
          });
          callback(options);
        }
      });
    }
  }

  const loadTulajdonsagOptions = (input, callback) => {
    Services.listTulajdonsag((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.leiras.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadEsemenyTipusOptions = (input, callback) => {
    Services.listEsemenyTipus((err, res) => {
      if (!err) {
        let options = [];
        res[0].list.filter( e => e.cap.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          if (item.nam === res[0].default) {
            handleSelectInputChange({nam: item.nam, cap: item.cap, res: item.res, pur: item.pur}, "formEsemenyTipus");
            }

          options.push(item);
        });
        callback(options);
      }
    });
  }

  const formatCreateLabel = (input) => (
    <span><i>Hozzáadás: </i> {input}</span>
  );

  const style = {
    margin: '10px'
  }

  const createIdoOption = (text) => {
    if (!/^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(text)) {
      globals.addError('Nem megfelelő idő formátum!');
      return;
    }
    handleAddIopont({label: text, value: text});
  }

  return (
    <React.Fragment>
      <div className="row" style={style} >
        <div className="col-md-6">
          {jegySWExists ?
            <React.Fragment>
              <SelectField
                label='Teremkiosztás:'
                variant='async'
                styles={{
                  control: base => ({
                    ...base,
                    marginBottom: '20px'
                  }),
                }}
                id={"formTeremkiosztas"}
                name={"formTeremkiosztas"}
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, "formTeremkiosztas")}
                loadOptions={_.debounce(loadTeremkiosztasOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.kod}
                value={formTeremkiosztas}
                cache={false}
                isClearable
                defaultOptions
                //defaultOptions
              />
            </React.Fragment>
          :
            <React.Fragment>
              <SelectField
                label='Terem:'
                variant='async'
                styles={{
                  control: base => ({
                    ...base,
                    marginBottom: '20px'
                  }),
                }}
                id={"formTerem"}
                name={"formTerem"}
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, "formTerem")}
                loadOptions={_.debounce(loadTeremOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={formTerem}
                cache={false}
                isClearable
                defaultOptions
              />
            </React.Fragment>}
        </div>
      </div>
      <div className="row" style={style}>
        <div className="col-md-6">
          <SelectField
            variant='async'
            label='Tulajdonság:'
            styles={{
              control: base => ({
                ...base,
                marginBottom: '20px'
              }),
            }}
            id={"formTulajdonsag"}
            name={"formTulajdonsag"}
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, "formTulajdonsag")}
            loadOptions={_.debounce(loadTulajdonsagOptions, 1000)}
            getOptionLabel={option => option.leiras || option.megjelenes || option.azonosito}
            getOptionValue={option => option.id}
            value={formTulajdonsag}
            cache={false}
            isClearable
            defaultOptions
          />
        </div>
      </div>
      <div className="row" style={style}>
        <div className="col-md-3">
            <RFField
              label={'Max. jegyszám: '}
              regex={['^[0-9]*$', 'Számokat tartalmazó mező!']} 
              name={"formMaxjegyszam"}
              id={"formMaxjegyszam"}
              type="text"
              value={formMaxjegyszam}
              onChange={handleChangeInput}
            />
        </div>
        <div className='col-md-3'>
          <SelectField
            label='Pénznem:'
            styles={{
              control: base => ({
                ...base,
                '&:focus': { borderColor: 'red' }, // border style on hover
                border: '1px solid lightgray', // default border color
                boxShadow: 'none', // no box-shadow
                borderRadius: '0',
                marginBottom: '20px'
              }),
            }}
            id={"formPenznem"}
            name={"formPenznem"}
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, "formPenznem")}
            //loadOptions={_.debounce(loadPenznemOptions, 1000)}
            options={penznemOptions}
            getOptionLabel={option => option.azonosito}
            getOptionValue={option => option.id}
            value={formPenznem}
            cache={false}
            isClearable
            defaultOptions
          />
        </div>
        {kenyelmiDijParam && <>
          <div className="col-md-3">
            <RFField
              label={'Kényelmi díj összege:'}
              regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']} 
              name={"formKenyelmidij"}
              id={"formKenyelmidij"}
              type="text"
              value={formKenyelmidij}
              autoComplete="off"
              onKeyDown={(e) => {
                if (!kenyelmiDijInputChecker(e, e.target.value, formPenznem?.tizedesjegy))
                  e.preventDefault();
              }}
              onChange={(e,v) => {
                if (kenyelmiDijInputChecker(e, v, formPenznem?.tizedesjegy))
                  handleChangeInput(e);
              }}
            />
          </div>
          <div className="col-md-3">
            <RFField
              label={'Kényelmi díj %: '}
              regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']} 
              name={"formKenyelmidijsz"}
              id={"formKenyelmidijsz"}
              type="text"
              value={formKenyelmidijsz}
              autoComplete="off"
              onKeyDown={(e) => {
                if (!kenyelmiDijInputChecker(e, e.target.value, 2))
                  e.preventDefault();
              }}
              onChange={(e,v) => {
                if (kenyelmiDijInputChecker(e, v, 2))
                  handleChangeInput(e);
              }}
              errorMessage={'Százalékot tartalmazó mező!'}
            />
          </div>
        </>}
      </div>
      <div className="row" style={style}>
        <div className="col-md-3">
          <SelectField
            variant='async'
            label='Esemény típusa:'
            styles={{
              control: base => ({
                ...base,
                marginBottom: '20px'
              }),
            }}
            id={"formEsemenyTipus"}
            name={"formEsemenyTipus"}
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => handleSelectInputChange(v, "formEsemenyTipus")}
            loadOptions={_.debounce(loadEsemenyTipusOptions, 1000)}
            getOptionLabel={option => option.cap}
            getOptionValue={option => option.nam}
            value={formEsemenyTipus}
            cache={false}
            isClearable
            defaultOptions
          />
        </div>
        <div className="col-md-3">
            <RFField
              regex={['^[0-9]*$', 'Számokat tartalmazó mező!']}
              label={'Rendelés időlimit (perc): '}
              name={"formRendelesIdoLimit"}
              id={"formRendelesIdoLimit"}
              type="text"
              value={formRendelesIdoLimit}
              onChange={handleChangeInput}
            />
        </div>
        <div className="col-md-3">
            <Label for={"formRendelesTorlesIdoLimit"} > időlimit (perc): 
              <i
                style={{ marginTop: 0 }}
                id={"formRendelesTorlesIdoLimitInfo"}
                aria-label="Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások."
                className="fa fa-info-circle table-action-icon transp-icon-button"
              />
              <UncontrolledTooltip trigger='hover focus-visible'
                placement="top"
                target={"formRendelesTorlesIdoLimitInfo"}
                delay={0}
              >
                {' Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások.'}
              </UncontrolledTooltip>
            </Label>
            <RFField
              regex={['^-?[0-9]*$', 'Számokat tartalmazó mező!']}
              name={"formRendelesTorlesIdoLimit"}
              id={"formRendelesTorlesIdoLimit"}
              type="text"
              value={formRendelesTorlesIdoLimit}
              onChange={handleChangeInput}
            />
        </div>
        <div className="col-md-2" style={{marginTop: "34px"}}>
          <div>
            <RFField
            label={'Publikus'}
              type="checkbox" 
              name={"formPublikus"}
              value={formPublikus}
              onChange={handleChangeInput}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h6>Időpont választás</h6> 
          <span>Előadás időtartama: {formEloadasIdotartam + ' perc'}</span>
        </div>  
        <div className="row">
          <div className="col-md-12">
            <SelectButtons
              datas={csoportDays}
              addWeek={addWeek}
              selectDay={selectDay}
              selectedDays={selectedDays}
            >
            </SelectButtons>
          </div>
        </div>
        <div className="row" style={{marginTop: '15px'}}>
          <div className="col-md-12">
            <SelectField
              variant='creatable'
              name="formIdopontok"
              id="formIdopontok"
              placeholder="Időpontok kiválasztása..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              formatCreateLabel={formatCreateLabel}
              onChange={v => handleSelectInputChange(v, "formIdopontok")}
              onCreateOption={createIdoOption}
              isMulti
              options={csoportosIdoOptions}
              getOptionLabel={option => option.label}
              getOptionValue={option => option.value}
              value={formIdopontok}
              cache={false}
            />
          </div>  
        </div>
      </div>
    </React.Fragment>
  );
}

export default CsoportosForm;